
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/cookie",
      function () {
        return require("private-next-pages/legal/cookie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/cookie"])
      });
    }
  